import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import LoginPage from "./pages/login";
import LandingPage from "./pages/landing";
import { useAuth } from "./context/AuthContext";
import Home from "./pages/home/index";
import Appointments from "./pages/appointment";
import Students from "./pages/students";
import Exercises from "./pages/exercises";
import Reports from "./pages/reports";
import LinkThree from "./pages/linkthree";
import Perfil from "./pages/perfil";
import Conversations from "./pages/conversations";
import MainLayout from "./tailadmin/layout/MainLayout";
import AdminOverview from "./pages/admin/overview";
import PrivacyPolicyPage from "./pages/privacy";
import Documentacoes from "./pages/documentacoes";
import DocumentacaoDetail from "./pages/documentacoes/[id]";
import studentsService from "./services/students";
import Load from "./components/ui/Load";

const LoginRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkStudents = async () => {
      if (user?.id) {
        try {
          const data = await studentsService.listAll(String(user.id));
          if (data?.students && data.students.length === 0) {
            navigate("/appointments?onboarding=1", { replace: true });
          } else {
            navigate("/appointments", { replace: true });
          }
        } catch (error) {
          navigate("/appointments", { replace: true });
        }
      } else {
        navigate("/appointments", { replace: true });
      }
    };
    checkStudents();
  }, [user, navigate]);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <Load />
    </div>
  );
};

function Routes() {
  const { isLogged } = useAuth();
  const LINKTHREE = {
    path: "/s/:id",
    element: <LinkThree />,
  };

  const PRIVACY_ROUTE = {
    path: "/politica-de-privacidade",
    element: <PrivacyPolicyPage />,
  };

  const authRoute = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/signin",
      element: <LoginPage />,
    },
    {
      path: "/signup",
      element: <LoginPage />,
    },
    LINKTHREE,
    PRIVACY_ROUTE,
    {
      path: "*",
      element: <LandingPage />,
    },
  ]);

  const userStack = createBrowserRouter([
    {
      element: <MainLayout />,
      children: [
        {
          path: "/",
          element: <Navigate to="/appointments" replace />,
        },
        {
          path: "/dashboard",
          element: <Home />,
        },
        {
          path: "/admin/overview",
          element: <AdminOverview />,
        },
        {
          path: "/login",
          element: <LoginRedirect />,
        },
        {
          path: "/signin",
          element: <LoginRedirect />,
        },
        {
          path: "/signup",
          element: <LoginRedirect />,
        },
        {
          path: "/appointments",
          element: <Appointments />,
        },
        {
          path: "/students",
          element: <Students />,
        },
        {
          path: "/exercises",
          element: <Exercises />,
        },
        {
          path: "/reports",
          element: <Reports />,
        },
        {
          path: "/conversations",
          element: <Conversations />,
        },
        {
          path: "/perfil",
          element: <Perfil />,
        },
        {
          path: "/documentacoes",
          element: <Documentacoes />,
        },
        {
          path: "/documentacoes/:id",
          element: <DocumentacaoDetail />,
        },
      ],
    },
    LINKTHREE,
    PRIVACY_ROUTE,
    {
      path: "*",
      element: <Navigate to="/appointments" replace />,
    },
  ]);

  return (
    <div>
      {isLogged ? (
        <RouterProvider router={userStack} />
      ) : (
        <RouterProvider router={authRoute} />
      )}
    </div>
  );
}

export default Routes;
